export const UPDATE_FILTER_SETTINGS = 'UPDATE_FILTER_SETTINGS';

export const updateFilterSettings = (settings, type) => {
    return {
        type: UPDATE_FILTER_SETTINGS,
        filterSettings: settings,
        filterType: type
    }
}